import type { KeyboardEvent } from 'react'

const INTERACTIVE_ELEMENT_SELECTOR = 'button, a, input, select, textarea'

// Releasing the mouse after selecting text still fires a click on the element
export const isTextSelected = () => !!window.getSelection()?.toString()

// Enter pressed on a control inside the row belongs to that control. Menus
// and dialogs opened from the row render in portals, so their key presses
// bubble through React to the row without being inside it in the DOM.
export const isEnterOnRow = (event: KeyboardEvent<HTMLElement>) =>
  event.key === 'Enter' &&
  event.currentTarget.contains(event.target as Node) &&
  !(event.target as HTMLElement).closest(INTERACTIVE_ELEMENT_SELECTOR)

export const getClickableRowProps = <T>(
  row: T,
  onRowClick?: (row: T) => void,
  isRowClickable: (row: T) => boolean = () => true
) => {
  if (!onRowClick || !isRowClickable(row)) return undefined

  return {
    tabIndex: 0,
    onClick: () => {
      if (!isTextSelected()) onRowClick(row)
    },
    onKeyDown: (event: KeyboardEvent<HTMLElement>) => {
      if (isEnterOnRow(event)) onRowClick(row)
    },
  }
}

export type ClickableRowProps = NonNullable<
  ReturnType<typeof getClickableRowProps>
>
